import { useLocation, useNavigate } from "react-router-dom";
import { ArrowBack as ArrowBackIcon } from "@mui/icons-material";
import { Box, Button, Typography } from "@mui/material";

import { PATHS } from "../../constants";

import notFoundImage from "./assets/not-found.png";

interface NotFoundPageProps {
  title?: string;
  message?: string;
}

const DEFAULT_NOT_FOUND_TITLE = "Не удалось открыть страницу";
const DEFAULT_NOT_FOUND_MESSAGE = "Возможно она удалена или ссылка некорректна";

export const NotFoundPage = ({
  title = DEFAULT_NOT_FOUND_TITLE,
  message = DEFAULT_NOT_FOUND_MESSAGE,
}: NotFoundPageProps): JSX.Element => {
  const navigate = useNavigate();
  const location = useLocation();

  // Ссылку могли открыть напрямую — тогда «назад» уведёт из приложения.
  // `key === "default"` у первой записи истории роутера.
  const handleBackClick = () => {
    if (location.key === "default") {
      navigate(PATHS.MAIN_PAGE, { replace: true });
    } else {
      navigate(-1);
    }
  };

  return (
    <Box
      sx={{
        alignItems: "center",
        display: "flex",
        flexDirection: "column",
        minHeight: "100vh",
        pt: "50px",
        px: 2,
        textAlign: "center",
      }}
    >
      <Box
        component="img"
        src={notFoundImage}
        alt={title}
        sx={{
          height: "auto",
          maxWidth: "100%",
          width: 384,
        }}
      />
      <Typography
        variant="h4"
        component="h1"
        sx={{
          color: ({ palette }) => palette.text.primary,
          fontWeight: 400,
          letterSpacing: 0,
          lineHeight: "100%",
          mt: "20px",
        }}
      >
        {title}
      </Typography>
      <Typography
        variant="h5"
        component="p"
        sx={{
          color: ({ palette }) => palette.text.primary,
          fontWeight: 400,
          letterSpacing: 0,
          lineHeight: "100%",
          mt: "18px",
        }}
      >
        {message}
      </Typography>
      <Button
        variant="contained"
        color="primary"
        startIcon={<ArrowBackIcon />}
        onClick={handleBackClick}
        sx={{ mt: "29px" }}
      >
        Вернуться
      </Button>
    </Box>
  );
};
